import React from "react";
import { Text } from "@merge-api/merge-javascript-shared";

type IPAddressCellProps = {
  ipAddress: string;
};

const IPAddressCell = ({ ipAddress }: IPAddressCellProps) => {
  return (
    // IP address is user PII and is thus masked at the cell
    <td className="ph-no-capture">
      <Text className="text-gray-40">{ipAddress}</Text>
    </td>
  );
};

export default IPAddressCell;
